import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { BugReport as BugReportIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const InvestigationNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        top: 0,
        mb: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button color="inherit" startIcon={<BugReportIcon />} onClick={() => navigate('/investigation')} sx={{ ml: 2 }}>
            {t('investigation.toolName')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default InvestigationNav
